import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { UserValidators } from '@app/classes/user-validators.class';
import { PATTERNS } from '@app/constants';
import { AuthService } from '@app/services';

@Component({
  templateUrl: './authentication-forgot-password.component.html',
  styleUrls: ['./authentication-forgot-password.component.scss']
})
export class AuthenticationForgotPasswordComponent implements OnInit {

  forgotPassEmail: FormControl;

  constructor(private dialog: DialogRef<AuthenticationForgotPasswordComponent>, private authServ: AuthService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.forgotPassEmail = new FormControl('', [
      Validators.required,
      UserValidators.patternValidator(PATTERNS.email, { validEmail: false })])
  }

  sendRecoverEmail() {
    if (this.forgotPassEmail.valid) {
      const email = (this.forgotPassEmail.value as string).toLocaleLowerCase();

      this.authServ.sendRecoverEmail({ email }).subscribe({
        next: (res) => {
          this.toastr.success('¡Se ha enviado un enlace de recuperación a tu correo. Revisa tu bandeja de entrada!');
          this.close();
        }
      })
    }
  }

  close() {
    this.dialog.close();
  }

}
